// Concretss × Sinners — PDP interactions
(function () {
  const root = document.querySelector('.merch-canvas.pdp');
  if (!root) return;
  const data = window.__PDP__ || { variants: [], options: [] };

  /* ---------------- Carousel ---------------- */
  const gallery = document.getElementById('pdp-gallery');
  if (gallery) {
    const slides = Array.from(gallery.querySelectorAll('.pdp-slide'));
    const dots = Array.from(gallery.querySelectorAll('.pdp-dot'));
    function go(idx) {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }
    dots.forEach((d) => d.addEventListener('click', () => go(parseInt(d.dataset.go, 10))));

    // swipe support (touch)
    let touchX = 0, touchT = 0, current = 0;
    gallery.addEventListener('touchstart', (e) => {
      touchX = e.touches[0].clientX;
      touchT = Date.now();
    }, { passive: true });
    gallery.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - touchX;
      const dt = Date.now() - touchT;
      if (Math.abs(dx) > 50 && dt < 600) {
        current = Math.max(0, Math.min(slides.length - 1, current + (dx < 0 ? 1 : -1)));
        go(current);
      }
    }, { passive: true });

    // sync `current` when user clicks dots
    dots.forEach((d, i) => d.addEventListener('click', () => { current = i; }));
  }

  /* ---------------- Variant selector ---------------- */
  const form = document.getElementById('pdp-form');
  const variantInput = document.getElementById('pdp-variant-id');
  const cta = document.getElementById('pdp-add');
  const priceEl = cta && cta.querySelector('.pdp-cta-price');
  const ctaLabel = cta && cta.querySelector('.pdp-cta-label');

  // selected[opt_idx] = value
  const selected = {};
  Array.from(root.querySelectorAll('.pdp-opt.is-selected')).forEach(btn => {
    selected[btn.dataset.optIndex] = btn.dataset.value;
  });

  function formatMoney(cents) {
    const v = (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '$' + v;
  }

  function findVariant() {
    return data.variants.find(v => {
      return data.options.every((optName, i) => v.options[i] === selected[i]);
    });
  }

  function syncDisplay() {
    Array.from(root.querySelectorAll('[data-current-value]')).forEach(el => {
      const i = el.dataset.currentValue;
      el.textContent = selected[i] || '—';
    });
    const v = findVariant();
    if (v) {
      variantInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (v.available) {
        cta.disabled = false;
        ctaLabel.textContent = 'AGREGAR AL CARRITO';
      } else {
        cta.disabled = true;
        ctaLabel.textContent = 'AGOTADO';
      }
    } else {
      cta.disabled = true;
      ctaLabel.textContent = 'NO DISPONIBLE';
    }
  }

  Array.from(root.querySelectorAll('.pdp-opt')).forEach(btn => {
    btn.addEventListener('click', (e) => {
      if (btn.classList.contains('is-sold')) return;
      const i = btn.dataset.optIndex;
      const v = btn.dataset.value;
      selected[i] = v;
      Array.from(root.querySelectorAll(`.pdp-opt[data-opt-index="${i}"]`)).forEach(b => {
        b.classList.toggle('is-selected', b.dataset.value === v);
      });
      syncDisplay();
    });
  });

  syncDisplay();

  /* ---------------- Size guide modal ---------------- */
  document.querySelectorAll('[data-open]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const id = btn.getAttribute('data-open');
      const modal = document.getElementById(id);
      if (modal) {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      }
    });
  });
  document.querySelectorAll('[data-close]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.getAttribute('data-close');
      const modal = document.getElementById(id);
      if (modal) {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.pdp-modal:not([hidden])').forEach((m) => {
        m.hidden = true;
        document.body.style.overflow = '';
      });
    }
  });

  /* ---------------- Description toggle (swap short ↔ full) ---------------- */
  const descShort = root.querySelector('.pdp-desc-short');
  const descFull = root.querySelector('.pdp-desc-full');
  root.querySelectorAll('.pdp-desc-toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!descShort || !descFull) return;
      const showFull = !descShort.hidden;
      descShort.hidden = showFull;
      descFull.hidden = !showFull;
    });
  });

  /* ---------------- AJAX add to cart with toast ---------------- */
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      cta.disabled = true;
      ctaLabel.textContent = 'AGREGANDO…';
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json' }
        });
        if (!r.ok) throw new Error('add failed');
        ctaLabel.textContent = 'AGREGADO ✓';
        // Open cart drawer instead of redirecting to /cart
        if (window.__merchCart) {
          setTimeout(() => { window.__merchCart.open(); }, 250);
        }
        setTimeout(() => {
          cta.disabled = false;
          ctaLabel.textContent = 'AGREGAR AL CARRITO';
        }, 1500);
      } catch (err) {
        cta.disabled = false;
        ctaLabel.textContent = 'ERROR — REINTENTAR';
      }
    });
  }
})();

